<template>
    <div class="activity-list">
        
        <div class="activity-goods" @click="onGoodsAdd"></div>
        <div class="activity-item" v-for="(item, index) in list" :key="index">
            <div class="activity-title">
                <span>商品{{index+1}}</span>
                <img v-show="list.length > 1" src="../../../assets/image/trash@2x.png" @click="onGoodsDel(index)" />
            </div>
            <InputItem class="perfer-input" :keyValue="item.goodPrice" keyName="goodPrice" :keyIndex="index" unit="元" :label="item.discountActivityId|getDiscountActivityLabel(columns)" placeholder="请输入" @change="inputChange"></InputItem>
            <div class="item1 jc">
                <span class="item1_1 info">数量</span>
                <div class="stepper_div">
                    <img v-if="!item.goodCount" class="stepper_img" :src="$theme.assist_icon_reduce_disable" />
                    <img v-else class="stepper_img" :src="$theme.assist_icon_reduce_default" @click="reduceFun(item,index)" />
                    <span class="stepper">{{item.goodCount}}</span>
                    <img class="stepper_img" :src="$theme.assist_icon_add_default" @click="addFun(item, index)"/>
                </div>
            </div>
            <div class="item1 jc">
                <div>
                    <span class="item1_1">未抹零金额</span>
                    <span class="item1_2">{{item.erasePrePriceString || '0.00'}}</span>
                </div>
                <div>
                    <span class="barge" v-show="item.discountStairDesc">{{item.discountStairDesc || ''}}</span>
                </div>
            </div>
            <div class="item1 jc">
                <div class="flex">
                    <span class="item1_1">优惠后总价</span>
                    <span class="item1_2">{{item.discountResultPrice || '0.00'}}</span>
                </div>
                <div class="flex">
                    <!-- <span class="item1_4">已优惠：1333.99</span> -->
                    <span class="barge barge-primary" v-show="item.eraseOddType">{{item.eraseOddType}}</span>
                </div>
            </div>
            <div class="item1">
                <span class="item1_1 info">参与活动</span>
                <div class="item1_3" @click="onActOpen(index)">
                    <span class="canyuhuoto-text">{{item.discountActivityId | getDiscountActivityId(columns)}}</span>
                    <img src="../../../assets/image/arrow_icon@2x.png" />
                </div>
            </div>
        </div>
        <!-- <div class="activity-goods" @click="onGoodsAdd">添加商品</div> -->

        <van-action-sheet v-model="actShow">
            <van-picker show-toolbar :columns="columns" :default-index="getCurrentListIndex" value-key="name" @confirm="onActConfirm" @cancel="onActChange"></van-picker>
        </van-action-sheet>
    </div>
</template>

<script>
import InputItem from './inputItem';
export default {
    props: {
        act: {
            default: function() {
                return []
            },
            type: Array
        },
        actId: {
            default: 0,
            type: Number
        },
        discountGoodSettleVoList: {
            default: function() {
                return []
            },
            type: Array
        }
    },
    data() {
        return {
            currentIndex: 0,
            widthSale: window.innerWidth / 750,
            list: [
                { goodCode: 1, goodSort: 1, goodPrice: '', discountActivityId: '', goodCount: 1 }
            ],
            actShow: false,
            columns: [
                { id: '', name: '不参与'}
            ]
        }
    },
    created() {
        this.columns.push(...this.act)
    },
    mounted() {
        document.body.addEventListener('touchstart',function(){});
    },
    filters: {
        getDiscountActivityId: function(id, columns) {
            let obj = columns.find(item=>item.id == id)
            return obj && obj.name || '不参与'
        },
        getDiscountActivityLabel: function(id, columns) {
            let obj = columns.find(item=>item.id == id)
            if(obj.discountType == 1) {
                return '吊牌价'
            } else if(obj.discountType == 2) {
                return '销售价'
            } else {
                return '销售价/吊牌价'
            }
        }
    },
    computed: {
        getCurrentListIndex: function() {
            return this.columns.findIndex(item=>item.id == this.list[this.currentIndex].discountActivityId)
        },
    },
    methods: {
        onActChange() {
            this.actShow = !this.actShow
        },
        onActConfirm(val) {
            this.list[this.currentIndex].discountActivityId = val.id
            this.onActChange()
        },
        onActOpen(index) {
            this.currentIndex = index
            this.actShow = !this.actShow
        },
        onGoodsDel(index) {
            this.currentIndex = 0
            this.list.splice(index, 1)
        },
        onGoodsAdd() {
            this.list.push({goodCount:1, goodCode: this.list[this.list.length-1].goodCode+1, goodSort: this.list[this.list.length-1].goodSort+1, goodPrice: '', discountActivityId: this.act.id||'' })
        },
        inputChange(e) {
            this.list[e.index][e.key] = e.value
        },
        reduceFun(row, idx){
            this.$set(this.list[idx], 'goodCount',Number(row.goodCount) - 1)
        },
        addFun(row, idx){
            this.$set(this.list[idx], 'goodCount',Number(row.goodCount) + 1)
        }
    },
    watch: {
        act: function(val) {
            this.columns = [{ id: '', name: '不参与'}, ...this.act]
            this.list.forEach(item=>{
                item.discountActivityId = this.actId
            })
        },
        actId: function(val) {
            this.list.forEach(item=>{
                item.discountActivityId = val
            })
        },
        discountGoodSettleVoList: function(val) {
            this.list.forEach((item,index)=>{
                this.$set(this.list, index, { ...item, ...this.discountGoodSettleVoList[index]})
            })
        },
    },
    components: {
        InputItem
    }
}
</script>

<style lang="less" scoped>
.activity-list {
    .activity-goods {
        position: fixed;
        top: 46px;
        right: 73px;
        z-index: 100;
        width: 100px;
        height: 100px;
        background: url(../../../assets/image/scrolltop1@2x.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        &:active {
            background: url(../../../assets/image/scrolltop2@2x.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
    }
    .activity-item:not(:last-child) {
        margin-bottom: 10px;
    }
    .activity-item {
        padding: 20px 50px 20px 40px;
        background-color: #fff;
        border-radius: 20px;
        .activity-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            span {
                display: inline-block;
                width: 180px;
                height: 63px;
                line-height: 63px;
                text-align: center;
                font-size: 24px;
                background-color: var(--epButtonColor);
                color: var(--epTextColor);
            }
            img {
                width: 44px;
                height: 44px;
            }
        }
        .jc {
            justify-content: space-between;
        }
        .flex {
            display: flex;
        }
        .item1 {
            display: flex;
            align-items: center;
            margin-top: 10px;
            .stepper_img{
                width: 40px;
                height: 40px;
            }
            .stepper {
                height: 40px;
                text-align: center;
                vertical-align: middle;
                font-size: 0.37rem;
                margin-left: 20px;
                margin-right: 20px;
            }
            .item1_1 {
                display: inline-block;
                width: 180px;
                height: 63px;
                line-height: 63px;
                text-align: right;
                font-size: 24px;
                flex-shrink: 0;

                &.info {
                    background-color: #f2f2f2;
                    text-align: center;
                }
            }
            .item1_2 {
                display: inline-block;
                max-width: 241px;
                height: 63px;
                line-height: 63px;
                font-size: 24px;
                padding: 0 40px;
                box-sizing: border-box;
            }
            .item1_3 {
                width: 100%;
                height: 63px;
                line-height: 63px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                border: 2px solid #ddd;
                border-left: none;
                box-sizing: border-box;

                span {
                    font-size: 24px;
                }
                img {
                    width: 44px;
                    height: 44px;
                }
            }
            .item1_4 {
                height: 50px;
                line-height: 50px;
                font-size: 24px;
                color: #F8A651;
                max-width: 200px;
                border-radius: 10px;
                background-color: #FFF8F1;
                text-align: center;
                white-space: nowrap;
                margin-right: 10px;
                padding: 0 8px;
                box-sizing: border-box;
            }
        }
    }

    .barge {
        display: inline-block;
        width: 250px;
        padding: 0 20px;
        // height: 50px;
        box-sizing: border-box;
        text-align: center;
        line-height: 40px;
        background-color: #ffe7e6;
        border-radius: 10px;
        font-size: 24px;
        color: #ED3939;
        font-weight: 500;

        &.barge-primary {
            color: #409EFF;
            background-color: #F0F7FF;
            white-space: nowrap;
        }
    }
}

/deep/ .van-stepper--round {
     .van-stepper__minus {
        color: var(--epTextColor);
        background-color: var(--epButtonColor);
        border-color:var(--epButtonColor) ;
     }
     .van-stepper__minus--disabled {
        color: #333;
        background-color:#ccc;
        border-color:#ccc;
     }
     .van-stepper__plus {
        background-color: var(--epButtonColor);
        color: var(--epTextColor);
    }
} 
.canyuhuoto-text {
    max-width: 400px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>